import { gql } from "@apollo/client";

export const FETCH_LIVE_FORECAST_TRACKING_DATA = gql`
  query FetchLiveForecastTrackingData(
    $cycleId: String!
    $adoptedMixId: String!
  ) {
    me {
      mmm {
        performanceTracking {
          liveForecast(cycleId: $cycleId, adopted_mix_id: $adoptedMixId) {
            data {
              date
              kpis {
                key
                value
              }
              spend_datacolumns {
                key
                value
              }
            }
          }
        }
      }
    }
  }
`;

export const FETCH_PERFORMANCE_TRACKING_DATA = gql`
  query FetchPerformanceTrackingData($cycleId: String!, $kpiId: String!) {
    me {
      mmm {
        performanceTracking {
          performanceTrackingSpendData(cycleId: $cycleId) {
            key
            breakdowns
            dailyMetrics {
              date
              actual
              budgeted
            }
            actualSpend
            actualSpendMix
            budgetedSpend
            budgetedSpendMix
            mtaRevenue
            mtaTransactions
            mtaRoas
            mtaCac
            dataColumnName
          }
          performanceTrackingKpiData(cycleId: $cycleId, kpiId: $kpiId) {
            planningTarget
            targetRange {
              low
              median
              high
            }
            dailyMetrics {
              date
              actual
              planningTarget
              targetRange {
                low
                median
                high
              }
            }
            weeklyMetrics {
              dateRange {
                startDate
                endDate
              }
              actual
              planningTarget
              targetRange {
                low
                median
                high
              }
            }
          }
        }
      }
    }
  }
`;

export const FETCH_PERFORMANCE_TRACKING_SUMMARY = gql`
  query FetchPerformanceTrackingSummary($cycleId: String!, $kpiId: String!) {
    me {
      mmm {
        performanceTracking {
          summary(cycleId: $cycleId, kpiId: $kpiId)
        }
      }
    }
  }
`;
